import { render, staticRenderFns } from "./SpinnerRipple.vue?vue&type=template&id=bdc22bba&functional=true"
import script from "./SpinnerRipple.vue?vue&type=script&lang=js"
export * from "./SpinnerRipple.vue?vue&type=script&lang=js"
import style0 from "./SpinnerRipple.vue?vue&type=style&index=0&id=bdc22bba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports